import { AppState } from "../../store";

export const selectCountries = (state: AppState) => state.reducer.Lookup.countryList;
export const getBoatSeriesList = (state: AppState) => state.reducer.Lookup.boatSeriesList;
export const getYearList = (state: AppState) => state.reducer.Lookup.yearList;
export const getRevisionList = (state: AppState) => state.reducer.Lookup.revisionList;
export const getDesignationTypes = (state: AppState) => state.reducer.Lookup.designationTypes;